import { Routes } from '@angular/router';
import { secureUploadExternalResolver } from './pages/secure-upload-external/secure-upload-external.resolver';
import { legacyDownloadRedirectResolver } from './pages/legacy-download-redirect/legacy-download-redirect.resolver';

export const routes: Routes = [
  {
    // Landing page for backend auth-error redirects (`/?authError=…&formId=…`).
    path: '',
    loadComponent: () =>
      import('./pages/auth-error/auth-error.component').then(m => m.AuthErrorComponent),
  },
  {
    path: 'form/:formId',
    loadComponent: () =>
      import('./pages/form-renderer/form-renderer.component').then(
        m => m.FormRendererPageComponent,
      ),
  },
  {
    path: 'assigned-form/:assignedFormId',
    loadComponent: () =>
      import('./pages/assigned-form/assigned-form.component').then(
        m => m.AssignedFormPageComponent,
      ),
  },
  {
    path: 'secureupload/:formId',
    loadComponent: () =>
      import('./pages/secure-upload/secure-upload.component').then(
        m => m.SecureUploadPageComponent,
      ),
  },
  {
    path: 'form/:companyName/:formId',
    loadComponent: () =>
      import('./pages/backward-compat/backward-compat.component').then(
        m => m.BackwardCompatComponent,
      ),
  },
  // --- Backward-compatibility for legacy FormGenerator MVC URLs (PascalCase, case-sensitive) ---
  // Emailed / hardcoded links (Portal, Signing, SupportTool) point at the old DNS, now the SPA.
  {
    path: 'SecureUpload/External/:secureUploadIdentifier',
    resolve: { redirect: secureUploadExternalResolver },
    children: [],
  },
  {
    path: 'SecureUpload/Download/:submissionId',
    data: { kind: 'download' },
    resolve: { redirect: legacyDownloadRedirectResolver },
    children: [],
  },
  {
    path: 'SecureUpload/DownloadFiles/:submissionId',
    data: { kind: 'downloadfiles' },
    resolve: { redirect: legacyDownloadRedirectResolver },
    children: [],
  },
  {
    path: 'SecureUpload/:formId',
    loadComponent: () =>
      import('./pages/secure-upload/secure-upload.component').then(
        m => m.SecureUploadPageComponent,
      ),
  },
  {
    // Legacy FormGenerator direct-form link casing: it registered `secureUpload/{formId}`
    path: 'secureUpload/:formId',
    loadComponent: () =>
      import('./pages/secure-upload/secure-upload.component').then(
        m => m.SecureUploadPageComponent,
      ),
  },
  {
    // New SPA-style receipt route.
    path: 'receipt/:orderId',
    loadComponent: () =>
      import('./pages/receipt/receipt.component').then(m => m.ReceiptPageComponent),
  },
  {
    // Legacy FormGenerator MVC receipt link (PascalCase).
    path: 'Forms/Receipt/:orderId',
    loadComponent: () =>
      import('./pages/receipt/receipt.component').then(m => m.ReceiptPageComponent),
  },
  {
    path: 'canceled',
    loadComponent: () =>
      import('./pages/canceled/canceled.component').then(
        m => m.CanceledPageComponent,
      ),
  },
  { path: '**', redirectTo: 'form/not-found' },
];
